import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { apiService } from '@/api/apiService'
import store, { ActionTypes } from '@/store';
import { getUserRoles } from '@/api/globalUtils';

// Lazy loading dei componenti - caricati solo quando necessari
const DefaultLayout = () => import('@/layouts/DefaultLayout.vue')
const Login = () => import('@/views/pages/Login.vue')
const Logout = () => import('@/views/pages/Logout.vue')
const Filiali = () => import('@/views/pages/Filiali.vue')
const Test = () => import('@/views/pages/Test.vue')
const RicambiEntrata = () => import('@/views/pages/RicambiEntrata.vue')
const Gallery = () => import('@/views/pages/Gallery.vue')
const Home = () => import('@/views/pages/Home.vue')
const UbicazioneAuto = () => import('@/views/pages/UbicazioneAuto.vue')
const Impostazioni = () => import('@/views/pages/Impostazioni.vue')
const ImpostazioniParcheggi = () => import('@/components/impostazioni/impostazioniParcheggi.vue')
const ImpostazioniTipoAllegati = () => import('@/components/impostazioni/impostazioniTipoAllegati.vue')
const ImpostazioniActivity = () => import('@/components/impostazioni/impostazioniActivity.vue')
const ImpostazioniActivityAnalisi = () => import('@/components/impostazioni/impostazioniActivityAnalisi.vue')
const ImpostazioniTargheCambioGomme = () => import('@/components/impostazioni/impostazioniTargheCambioGomme.vue')
const ImpostazioniParametriGenerali = () => import('@/components/impostazioni/impostazioniParametriGenerali.vue')
const ImpostazioniPortaleClienti = () => import('@/components/impostazioni/impostazioniPortaleClienti.vue')
const ImpostazioniTrigger = () => import('@/components/impostazioni/impostazioniTrigger.vue')
const impostazioniTerzisti = () => import('@/components/impostazioni/impostazioniTerzisti.vue')
const impostazioniAiArticoliAssociazione = () => import('@/components/impostazioni/impostazioniAiArticoliAssociazione.vue')
const impostazioniFasi = () => import('@/components/impostazioni/impostazioniFasi.vue')
const impostazioniSlot = () => import('@/components/impostazioni/impostazioniSlot.vue')
const impostazioniInvioMail = () => import('@/components/impostazioni/impostazioniInvioMail.vue')
const impostazioniInvioSms = () => import('@/components/impostazioni/impostazioniInvioSms.vue')
const impostazioniUtenti = () => import('@/components/impostazioni/impostazioniUtenti.vue')
const impostazioniMessaggiModelli = () => import('@/components/impostazioni/impostazioniMessaggiModelli.vue')
const impostazioniLinkentry = () => import('@/components/impostazioni/impostazioniLinkentry.vue')
const impostazioniFlow = () => import('@/components/impostazioni/impostazioniFlow.vue')
const impostazioniServizi = () => import('@/components/impostazioni/impostazioniServizi.vue')
const lavoroExtra = () => import('@/views/pages/commessa/lavoroExtra.vue')
const CommessaCrea1 = () => import('@/views/pages/commessa/commessaCrea.vue')
const CommessaCrea = () => import('@/views/pages/commessa/nuovaCommessa.vue')
const GestioneCommessa = () => import('@/views/pages/commessa/GestioneCommessa.vue')
const ApriCommessa = () => import('@/views/pages/commessa/apriCommessa.vue')
const AutomezzoEditNew = () => import('@/views/pages/automezzo/AutomezzoEditNew.vue')
const AutomezzoGestione = () => import('@/views/pages/automezzo/AutomezzoGestione.vue')
const AutomezzoSearch = () => import('@/views/pages/automezzo/AutomezzoSearch.vue')
const ImportTarghe = () => import('@/views/pages/automezzo/ImportTarghe.vue')
const ImportReport = () => import('@/views/pages/automezzo/ImportReport.vue')
const ImportLibrettiReport = () => import('@/views/pages/automezzo/ImportLibrettiReport.vue')
const ListaRichiamoTyre = () => import('@/views/pages/ListaRichiamoTyre.vue')
const Gomme = () => import('@/views/pages/Gomme.vue')
const LogApp = () => import('@/views/pages/LogViewer.vue')
const Timbratura = () => import('@/views/pages/Timbratura.vue')
const ListaCommesse = () => import('@/views/pages/ListaCommesse.vue')
const Agenda = () => import('@/views/pages/Agenda.vue')
const GestioneAgenda = () => import('@/views/pages/agenda/gestioneAgenda.vue')
const EsempioTabella = () => import('@/views/pages/EsempioTabella.vue')
const AnagraficaSearch = () => import('@/views/pages/anagrafica/AnagraficaSearch.vue')
  const AnagraficaDetail = () => import('@/views/pages/anagrafica/AnagraficaDetail.vue')
const TracklistRicerca = () => import('@/views/pages//tracklist/ricercaTracklist.vue')
const TracklistDettaglio = () => import('@/views/pages//tracklist/gestioneTracklist.vue')
const OfficinaEsternaLista = () => import('@/views/pages/tracklist/officinaEsterna.vue')
const OfficinaEsternaDetail = () => import('@/views/pages/tracklist/officinaEsternaDetail.vue')
const PreCheckRicerca = () => import('@/views/pages/tracklist/preCheckRicerca.vue')
const PreCheckInserimento = () => import('@/views/pages/tracklist/preCheckInserimento.vue')
const CheckOperatore = () => import('@/views/pages/check/CheckOperatore.vue')
const CheckGestione = () => import('@/views/pages/check/CheckGestione.vue')
const CheckGestioneDettaglio = () => import('@/views/pages/check/CheckGestioneDettaglio.vue')
const CalendarioAttivita = () => import('@/views/pages/check/CalendarioAttivita.vue')
const ParcoMezzi = () => import('@/views/pages/check/ParcoMezzi.vue')
const User = () => import('@/views/pages/User.vue')
const Viste = () => import('@/views/pages/viste/Viste.vue')
const AiAssistente = () => import('@/views/pages/ai/AiAssistente.vue')

const routes: Array<RouteRecordRaw> = [
 {
    path: '/timbratura',
    name: 'timbratura',
    meta: { title: 'Gestione Timbratura', requiresAuth: true },
    component: Timbratura,
  },
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: { title: 'Filiali', requiresAuth: true },
        component: Home,
      },
      {
        path: '/impostazioni',
        name: 'impostazioni',
        meta: { title: 'Impostazioni APP', requiresAuth: true },
        children: [
          {
            path: 'logapp',
            name: 'logapp',
            meta: { title: 'logapp', requiresAuth: true },
            component: LogApp,
          },
          {
            path: 'parcheggi',
            name: 'impostazioniParcheggi',
            meta: { title: 'Impostazioni Parcheggi', requiresAuth: true },
            component: ImpostazioniParcheggi,
          },
          {
            path: 'tipoallegati',
            name: 'impostazioniTipoAllegati',
            meta: { title: 'Impostazioni Tipologia Allegati', requiresAuth: true },
            component: ImpostazioniTipoAllegati,
          },
          {
            path: 'targhecambiogomme',
            name: 'impostazioniTargheCambioGomme',
            meta: { title: 'Impostazioni Targhe autorizzate per cambio gomme', requiresAuth: true },
            component: ImpostazioniTargheCambioGomme,
          },
          {
            path: 'activity',
            name: 'impostazioniActivity',
            meta: { title: 'Atttività', requiresAuth: true },
            component: ImpostazioniActivity,
          },
          {
            path: 'activity-analisi',
            name: 'impostazioniActivityAnalisi',
            meta: { title: 'Analisi modifiche', requiresAuth: true },
            component: ImpostazioniActivityAnalisi,
          },
          {
            path: 'parametri',
            name: 'impostazioniParametriGenerali',
            meta: { title: 'Parametri Generali', requiresAuth: true },
            component: ImpostazioniParametriGenerali,
          },
          {
            path: 'portaleclienti',
            name: 'impostazioniPortaleClienti',
            meta: { title: 'Portale Clienti', requiresAuth: true },
            component: ImpostazioniPortaleClienti,
          },
          {
            path: 'trigger',
            name: 'impostazioniTrigger',
            meta: { title: 'Trigger', requiresAuth: true },
            component: ImpostazioniTrigger,
          },
          {
            path: 'flow',
            name: 'impostazioniFlow',
            meta: { title: 'Wizard configurabili', requiresAuth: true },
            component: impostazioniFlow,
          },
          {
            path: 'terzisti',
            name: 'impostazioniTerzisti',
            meta: { title: 'Terzisti', requiresAuth: true },
            component: impostazioniTerzisti,
          },
          {
            path: 'fasi',
            name: 'impostazioniFasi',
            meta: { title: 'Fasi di Lavorazione', requiresAuth: true },
            component: impostazioniFasi,
          },
          {
            path: 'aiarticoliassociazione',
            name: 'aiarticoliassociazione',
            meta: { title: 'AI Articoli Associazione', requiresAuth: true },
            component: impostazioniAiArticoliAssociazione,
          },
          {
            path: 'impostazioniSlot',
            name: 'impostazioniSlot',
            meta: { title: 'impostazioniSlot', requiresAuth: true },
            component: impostazioniSlot,
          },
          {
            path: 'invioemail',
            name: 'impostazioniInvioMail',
            meta: { title: 'Coda email', requiresAuth: true },
            component: impostazioniInvioMail,
          },
          {
            path: 'inviosms',
            name: 'impostazioniInvioSms',
            meta: { title: 'Coda SMS', requiresAuth: true },
            component: impostazioniInvioSms,
          },
          {
            path: 'utenti',
            name: 'impostazioniUtenti',
            meta: { title: 'Gestione Utenti App', requiresAuth: true },
            component: impostazioniUtenti,
          },
          {
            path: 'messaggimodelli',
            name: 'impostazioniMessaggiModelli',
            meta: { title: 'Modelli Messaggi SMS/Mail', requiresAuth: true },
            component: impostazioniMessaggiModelli,
          },
          {
            path: 'linkentry',
            name: 'impostazioniLinkentry',
            meta: { title: 'Sincronizzazioni LinkEntry', requiresAuth: true },
            component: impostazioniLinkentry,
          },
          {
            path: 'servizi',
            name: 'impostazioniServizi',
            // meta.roles: la guardia sotto blocca chi non ha il ruolo (l'API rifiuta comunque le scritture)
            meta: { title: 'Servizi', requiresAuth: true, roles: ['admins'] },
            component: impostazioniServizi,
          },
        ],
      },
      {
        path: '/tyre',
        name: 'tyre',
        meta: { title: 'Gestione Tyre', requiresAuth: true },
        children: [
          {
            path: 'richiamotyre',
            name: 'listaRichiamoTyre',
            meta: { title: 'Lista Richiamo Tyre', requiresAuth: true },
            component: ListaRichiamoTyre,
          },
        ],
      },
      {
        path: '/viste',
        name: 'Viste',
        meta: { title: 'Viste', requiresAuth: true },
        component: Viste,

      },
      {
        // chat con l'assistente AI: serve il ruolo dedicato, verificato anche dall'API (gate "use-ai")
        path: '/assistente',
        name: 'AiAssistente',
        meta: { title: 'Assistente AI', requiresAuth: true, roles: ['assistente-ai'] },
        component: AiAssistente,
      },
      {
        path: '/user',
        name: 'User',
        meta: { title: 'User', requiresAuth: true },
        component: User,
      },
      {
        path: '/agenda',
        name: 'agenda',
        meta: { title: 'Agenda', requiresAuth: true },
        component: Agenda,
      },
      {
        path: '/agenda/gestione',
        name: 'gestioneagenda',
        meta: { title: 'Gestione Agenda', requiresAuth: true },
        component: GestioneAgenda,
      },
      {
        path: '/gomme/:targa',
        name: ' ',
        meta: { title: 'Gestione Gomme Automezzo', requiresAuth: true },
        component: Gomme,
        props: true 

      },
      {
        path: '/automezzoricerca',
        name: 'automezzoricerca',
        meta: { title: 'Ricerca Automezzo', requiresAuth: true },
        component: AutomezzoSearch,
      },
      {
        path: '/automezzo',
        name: 'automezzo',
        meta: { title: 'Gestione Automezzo', requiresAuth: true },
        component: AutomezzoEditNew,
      },
      {
        path: '/automezzo/importtarghe',
        name: 'importtarghe',
        meta: { title: 'Import Targhe', requiresAuth: true },
        component: ImportTarghe,
      },
      {
        path: '/automezzo/importtargheReport',
        name: 'importtargheReport',
        meta: { title: 'Report Import Targhe', requiresAuth: true },
        component: ImportReport,
      },
      {
        path: '/automezzo/importlibrettiReport',
        name: 'importlibrettiReport',
        meta: { title: 'Report Import Libretti', requiresAuth: true },
        component: ImportLibrettiReport,
      },
      {
        path: '/automezzo/:targa',
        name: 'automezzospecifico',
        meta: { title: 'Gestione Automezzo', requiresAuth: true },
        component: AutomezzoGestione,
        props: true

      },
      {
        path: '/gestionecommessa',
        name: 'gestionecommessa',
        meta: { title: 'Gestione Commessa', requiresAuth: true },
        component: ApriCommessa,
      },
     /*  {
        path: '/gestionecommessa/:numerolavoro',
        name: 'gestionecommessa',
        meta: { title: 'Gestione Commessa', requiresAuth: true },
        component: GestioneCommessa,
        props: true 
      }, */
      {
        path: '/commessaricerca',
        name: 'commessaricerca',
        meta: { title: 'Ricerca Commessa', requiresAuth: true },
        component: ListaCommesse,
      },
      {
        path: '/commessacrea/:targa?/:numerolavoro?',
        name: 'commessacrea',
        meta: { title: 'Creazione Commessa', requiresAuth: true },
        component: CommessaCrea,
        props: true 
      },
      {
        path: '/precheck',
        name: 'precheck',
        meta: { title: 'Ricerca PreCheck', requiresAuth: true },
        component: PreCheckRicerca,
      },
      {
        path: '/precheckins',
        name: 'precheckins',
        meta: { title: 'Inserisci PreCheck', requiresAuth: true },
        component: PreCheckInserimento,
      },
      {
        path: '/check',
        name: 'check',
        meta: { title: 'Check Veicoli', requiresAuth: true },
        component: CheckOperatore,
      },
      {
        path: '/check/gestione',
        name: 'checkgestione',
        meta: { title: 'Gestione Check', requiresAuth: true },
        component: CheckGestione,
      },
      {
        path: '/check/parcomezzi',
        name: 'parcomezzi',
        meta: { title: 'Parco mezzi', requiresAuth: true },
        component: ParcoMezzi,
      },
      {
        path: '/check/gestione/:id',
        name: 'checkgestionedettaglio',
        meta: { title: 'Gestione Check', requiresAuth: true },
        component: CheckGestioneDettaglio,
        props: true,
      },
      {
        path: '/calendario',
        name: 'calendario',
        meta: { title: 'Calendario', requiresAuth: true },
        component: CalendarioAttivita,
      },
      {
        path: '/tracklist',
        name: 'tracklist',
        meta: { title: 'Tracklist ricerca', requiresAuth: true },
        component: TracklistRicerca ,
        props: true
      },
      {
        path: '/tracklist/officina-esterna',
        name: 'officinaEsternaLista',
        meta: { title: 'Officina Esterna', requiresAuth: true },
        component: OfficinaEsternaLista,
      },
      {
        path: '/tracklist/officina-esterna/:id',
        name: 'officinaEsternaDetail',
        meta: { title: 'Officina Esterna - Dettaglio', requiresAuth: true },
        component: OfficinaEsternaDetail,
        props: true,
      },
      {
        path: '/tracklist/:id',
        name: 'tracklistdetail',
        meta: { title: 'Tracklist Dettaglio', requiresAuth: true },
        component: TracklistDettaglio,
        props: true

      },
      {
        path: '/anagrafica',
        name: 'anagrafica',
        meta: { title: 'Gestione Anagrafica', requiresAuth: true },
        component: AnagraficaSearch,
        props: true 

      },
      {
        path: '/anagrafica/new',
        name: 'anagraficanuova',
        meta: { title: 'Nuova Anagrafica', requiresAuth: true },
        component: AnagraficaDetail,
        props: { codice: 'new' }
      },
      {
        path: '/anagrafica/:codice',
        name: 'anagraficadetail',
        meta: { title: 'Dettaglio Anagrafica', requiresAuth: true },
        component: AnagraficaDetail,
        props: true
      },
      {
        path: '/gestionecommessa/:numerolavoro',
        name: 'gestionecommessaspecifica',
        meta: { title: 'Gestione Commessa', requiresAuth: true },
        component: GestioneCommessa,
        props: true 

      },
      {
        path: '/gestionecommessa/:numerolavoro/lavoroextra',
        name: 'gestionecommessa.lavoroextra',
        meta: { title: 'Lavoro Extra', requiresAuth: true },
        component: lavoroExtra,
        props: true 
      },
      {
        path: '/ricambientrata',
        name: 'ricambientrata',
        meta: { title: 'Controllo Ricambi Entrata', requiresAuth: true },
        component: RicambiEntrata,
      },
      {
        path: '/ubicazioneauto',
        name: 'ubicazioneauto',
        meta: { title: 'Ubicazione Auto', requiresAuth: true },
        component: UbicazioneAuto,
      },
      {
        path: '/gallery',
        name: 'gallery',
        meta: { title: 'Galleria allegati', requiresAuth: true },
        component: Gallery,
      },
      {
        path: '/test',
        name: 'test',
        meta: { title: 'test', requiresAuth: true },
        component: Test,
      },

    ],
  },
  { path: '/login', name: 'login', component: Login },
  { path: '/logout', name: 'logout', component: Logout },
  {
    path: '/filiali', name: 'filiali', component: Filiali,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})


// Funzione di esempio per verificare se l'utente è autenticato
const isAuthenticated = () => {
  // Qui dovresti inserire la tua logica di autenticazione.
  // Ad esempio, potresti controllare se è presente un token JWT nel localStorage,
  // o se lo stato dell'utente nel tuo store Vuex indica che è loggato.
  return store.state.isAuthenticated;
  //return localStorage.getItem('authToken') !== null; // Esempio semplice con localStorage
};

/** Ogni quanto, al massimo, riverificare (e rinnovare) il token durante la navigazione. */
const RIVERIFICA_TOKEN_MS = 10 * 60 * 1000;

/** Ultima verifica riuscita del token in questa sessione (0 = mai: la prossima e' bloccante). */
let tokenVerificatoAt = 0;

const esciPerTokenNonValido = () => {
  tokenVerificatoAt = 0;
  localStorage.removeItem('authToken');
  store.dispatch(ActionTypes.LOGOUT);
};

/** Token rifiutato durante la navigazione in background: la pagina e' gia' aperta. */
const esciAlLogin = () => {
  esciPerTokenNonValido();
  if (router.currentRoute.value.name !== 'login') router.push({ name: 'login' });
};

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    next();
    return;
  }

  if (!isAuthenticated()) {
    next({ name: 'login' });
    return;
  }

  // Rotte con meta.roles: accessibili solo a chi possiede almeno uno dei ruoli indicati.
  const ruoliRichiesti = (to.meta.roles ?? []) as string[];
  if (ruoliRichiesti.length) {
    const ruoliUtente = getUserRoles();
    if (!ruoliRichiesti.some((r) => ruoliUtente.includes(r))) {
      next({ name: 'dashboard' });
      return;
    }
  }

  // Prima navigazione della sessione: si aspetta la verifica, un token scaduto deve
  // finire al login prima che la pagina parta (e mostri errori su ogni chiamata).
  if (!tokenVerificatoAt) {
    try {
      const isValid = await apiService.checkToken();
      if (isValid) {
        tokenVerificatoAt = Date.now();
        next();
      } else {
        esciPerTokenNonValido();
        next({ name: 'login' });
      }
    } catch {
      next({ name: 'login' });
    }
    return;
  }

  // Dalle successive si naviga subito: aspettare /checktoken a ogni cambio pagina era un
  // giro di rete in serie prima di qualunque altra chiamata (in officina, secondi).
  // La verifica resta, in background e diradata, perche' e' anche quella che rinnova
  // la scadenza del token lato server.
  next();
  if (Date.now() - tokenVerificatoAt > RIVERIFICA_TOKEN_MS) {
    tokenVerificatoAt = Date.now();
    apiService.checkToken()
      .then((isValid) => {
        if (!isValid) esciAlLogin();
      })
      .catch((e: any) => {
        // solo un 401 vero fa uscire: un errore di rete in piazzale non deve buttare
        // fuori il tecnico, si riprovera' alla prossima navigazione utile
        if (e?.response?.status === 401) esciAlLogin();
        else tokenVerificatoAt = Date.now() - RIVERIFICA_TOKEN_MS;
      });
  }
});

// CModal (CoreUI) blocca lo scroll del body all'apertura (modal-open + overflow:hidden)
// e lo sblocca solo nella transizione di chiusura. Se si cambia pagina con un modale
// aperto (es. "Vai" sullo storico di una commessa aperta in modale dall'agenda) il
// componente viene smontato senza chiusura e il body resta bloccato fino al reload.
// Dopo ogni navigazione, se non c'e' piu' nessun modale aperto, si ripulisce il body.
router.afterEach(() => {
  setTimeout(() => {
    if (document.querySelector('.modal[aria-modal="true"]')) return;
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  });
});

export default router
